// Loaded first on every page (snippets/@head-scripts.liquid): browser polyfills.
import '@theme/vendor-polyfills'
